import TalentHelper from './models/TalentHelper';

export default { talents: TalentHelper };
